<div id="policy" class="side-padding">
  <h2 id="policy_h2">Notebooks offered in Noteable</h2>
  <p>
    Here are all the Notebook Servers with the respective primary libraries listed, which are currently available in
    Noteable.
  </p>
  <p>
    These are not a comprehensive lists, however it does list the libraries and extensions we have specifically chosen
    to install.<br />(see the &quot;Is there a full list of libraries installed in each notebook?&quot; answer in the
    <a href="/faq/#show_te_f">Technical Questions</a> section of the FAQ to get the <em>comprehensive</em> list)
  </p>
  <p>
    Hover over the library name for a brief description of that library, and the verson installed. Each library should
    also link you to documentation for that library.
  </p>
  @for (notebook of notebooks; track notebook.display_name) {
    <section [attr.aria-label]="'Description for ' + notebook.display_name">
      <h3 id="h3_{{ notebook.description.service }}">
        {{ notebook.display_name }}
      </h3>
      <h4 *ngIf="notebook.restricted" id="h4_{{ notebook.description.service }}_restricted">
        (Access granted to a restricted notebook)
      </h4>
      <p>{{ notebook.description.description }}</p>
      <ul>
        <!-- use a "pipe" to build the actual html: https://dzone.com/articles/why-we-shound-not-use-function-inside-angular-temp -->
        @for (section of notebook.description.sections; track $index) {
          <li [innerHTML]="section | getListItemText"></li>
        }
      </ul>
    </section>
  }
</div>
